import { useMutation } from '@tanstack/react-query';
import { openAccountSpot } from '../requests';
import type { OpenAccountResponseDto } from '../types';

interface UseOpenAccountSpotOptions {
  onSuccess?: (data: OpenAccountResponseDto) => void;
}

const useOpenAccountSpot = (options?: UseOpenAccountSpotOptions) => {
  const mutation = useMutation({
    mutationFn: openAccountSpot,
    onSuccess: options?.onSuccess,
  });

  return {
    openAccount: mutation.mutateAsync,
    isOpenAccountPending: mutation.isPending,
    isOpenAccountSuccess: mutation.isSuccess,
    isOpenAccountError: mutation.isError,
    openAccountData: mutation.data,
    openAccountError: mutation.error,
  };
};

export { useOpenAccountSpot };
